import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';

@Component({
    selector: 'app-address-form',
    templateUrl: './address-form.component.html',
    styleUrls: ['./address-form.component.scss'],
})
export class AddressFormComponent {
    @Input() loading: boolean = false;

    @Output() onSubmit = new EventEmitter<string>();

    form = new FormGroup(
        {
            query: new FormControl('', [Validators.required, Validators.minLength(3)]),
        },
        {
            updateOn: 'change',
        },
    );

    submitForm(): void {
        if (this.form.valid) {
            this.onSubmit.emit(this.form.value.query);
        }
    }
}
